/* eslint-disable import/prefer-default-export */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';

import styled, { css } from 'styled-components';
import { ml, mb } from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';

import theme from '@theme';

const { colors } = theme;

const Label = ({ children, required, ...props }) => (
  <label {...props}>
    {children}
    {required && '*'}
  </label>
);

const labelStyles = css`
  font-family: 'Open Sans', 'OpenSans', Raleway;

  ${ml(0)}
  cursor: pointer;

  ${breakpoint('desktop')`
    ${ml(0)}
  `}
`;

export const StyledLabelNew = styled(Label)`
  font-size: ${props => (props.treatmentFormName ? '16px' : '18px')};
  color: ${props => (props.treatmentFormName ? colors.white : colors.navyGray)};
  font-weight: 600;
  ${({ campaign }) => campaign
  && `
    color: black;
  `};
  ${breakpoint('mobile', 'tablet')`
    font-size: 14px; 
  `}
`;

export const StyledLabel = styled(Label)`
  ${labelStyles}
  color:${props => (props.white ? 'white' : '')};
  font-size: 12px;
  font-weight: 600;
  align-self: start;
  
  ${breakpoint('desktop')`
    color: ${({ finderForm }) => (finderForm ? colors.white : colors.darkBlue)};
  `}

  ${breakpoint('mobile', 'desktop')`
    color: ${({ flowForm }) => (flowForm ? colors.white : colors.darkBlue)};
    ${({ flowForm }) => (flowForm ? ml(0) : '')}
  `}
`;

export const StyledLabelPackageForm = styled(Label)`
  ${labelStyles}
  font-size: 12px;
  font-weight: 600;
  align-self: start;
  ${({ changeColor }) => changeColor && `color:${colors[changeColor]};`};
`;

export const StyledLabelLight = styled(Label)`
  ${labelStyles}
  display: inline-block;

  ${mb(3)}

  font-size: 18px;
`;
